import Swiper from 'swiper/bundle';
import { $Qll } from '../utils/query-selector';
import 'swiper/css/bundle';

const initCollectionNavCarousel = () => {
  const collectionCarousels = $Qll('.collection-nav-swiper');

  if (!collectionCarousels.length) return;

  collectionCarousels.forEach((collectionCarousel) => {
    new Swiper(collectionCarousel, {
      slidesPerView: 'auto',
      freeMode: true,
      spaceBetween: 32,
    });
  });
}

export default initCollectionNavCarousel;
